import ZJNotify from '../../notify';
import utils from '../../utils'
import H264Decoder from './H264Decoder'

//eslint-disable-next-line
const YUV_HEAD_SIZE = 48; // YUV 数据头长度
const STA = 0x44415441;

const YUVDeflateDecoder = function(opts) {
    this.config = opts = opts || {};
    this.$unzipBuffer = null;
    this.$h264 = null;
};

const pt = YUVDeflateDecoder.prototype;

// eslint-disable-next-line
pt.onDecoded = function(buffer, width, height, infos) {};

// eslint-disable-next-line
pt.onError = function(e) {};

pt.destroy = function() {
    this.$unzipBuffer = null;
    if (this.$h264) {
        this.$h264.destroy();
        this.$h264 = null;
    }
};

// 解码数据
pt.decodeData = function(data, offset, count) {
    let yuv = {};
    const reader = new ZJNotify.BinaryReader(data, offset, count);
    yuv.sta = reader.readInt32();        // 4 字节起始位，固定为 0x44415441
    yuv.dataSize = reader.readInt32();   // 4 字节数据长度
    yuv.rawDataSize = reader.readInt32();// 4 字节原始长度
    yuv.yStride = reader.readInt32();    // 4 字节 yStride
    yuv.uvStride = reader.readInt32();   // 4 字节 uvStride
    yuv.timestamp = reader.readInt32();  // 4 字节时间戳
    yuv.frameType = reader.readInt32();  // 4 字节帧类型
    yuv.width = reader.readInt32();      // 4 字节宽度
    yuv.height = reader.readInt32();     // 4 字节高度
    yuv.sendTime = reader.readUInt64();  // 8 字节发送时间
    yuv.zipMethod = reader.readInt8();   // 1 字节压缩方式
    yuv.reserve0 = reader.readInt8();    // 1 字节保留位
    yuv.reserve1 = reader.readInt16();   // 2 字节保留位
    
    if (yuv.sta != STA) {
        const e = new Error('Invalid STA');
        this.onError(e);
        return;
    }

    const yuvData = data.subarray(YUV_HEAD_SIZE, YUV_HEAD_SIZE + yuv.dataSize)

    if (yuv.zipMethod == 1) { // 解压
        if (!this.$unzipBuffer) {
            this.$unzipBuffer = new utils.Buffer(8 * 1024);
        }
        this.$unzipBuffer.count = 0;
        let unzipData = (new utils.ZipInflate())(yuvData, this.$unzipBuffer);
        yuv.data = unzipData;
        yuv.dataSize = unzipData.length;
        yuv.zipMethod = 0;
        if (yuv.dataSize != yuv.rawDataSize) {
            const e = new Error('Invalid DataSize');
            this.onError(e);
            return;
        }
        this.onDecoded(yuv.data, yuv.width, yuv.height, yuv);
    }
    else if (yuv.zipMethod == 2) { // h.264
        if (!this.$h264) {
            this.$h264 = new H264Decoder({
                useWorker: true,
                rgb: false,
                reuseMemory: true,
                transferMemory: false
            });
            const that = this;
            this.$h264.onDecoded = function(data, width, height, infos) {
                let yuv = infos[0];
                //console.log(data, width, height, yuv);
                yuv.data = data;
                yuv.dataSize = data.length;
                yuv.zipMethod = 0;
                yuv.oldWidth = yuv.width;
                yuv.oldHeight = yuv.height;
                yuv.oldYStride = yuv.yStride;
                yuv.oldUVStride = yuv.uvStride;
                yuv.width = width;
                yuv.height = height;
                yuv.yStride = width;
                yuv.uvStride = width / 2;
                that.onDecoded(yuv.data, yuv.width, yuv.height, yuv);
            };
        }
        //console.log(yuvData.length);
        this.$h264.decode(yuvData, yuv);
    }
    else {
        yuv.data = yuvData;
        this.onDecoded(yuv.data, yuv.width, yuv.height, yuv);
    }
};

pt.write = function(data, offset, count) {
    if (typeof offset === 'undefined') {
        offset = 0;
    }
    if (typeof count === 'undefined') {
        count = data.length - offset;
    }
    this.decodeData(data, offset, count);
};


export default YUVDeflateDecoder;
